import React, { memo } from 'react'
import dayjs from 'dayjs'

import { Quote, QuoteStatus } from '../../storage/types'
import { ItemValue } from '../../../../components/styled'
import TestIds from '../../../../testIds'

const Expiry = ({ quote }: { quote: Quote }) => {
  if (
    [
      QuoteStatus.Created,
      QuoteStatus.Requested,
      QuoteStatus.Rejected,
      QuoteStatus.Cancelled,
      QuoteStatus.Ordered,
    ].includes(quote.status)
  ) {
    return null
  }

  if (!quote.expiresOn) return null

  const expiresOn = dayjs(quote.expiresOn)

  if (quote.status === QuoteStatus.Expired || expiresOn.isBefore()) {
    return (
      <ItemValue variant='body2' data-testid={TestIds.feat.quotes.card.expiryDate}>
        Expired {expiresOn.format('DD MMM YYYY')}
      </ItemValue>
    )
  }

  if (expiresOn.isAfter()) {
    const dateString = dayjs().to(expiresOn)
    return (
      <ItemValue variant='body2' data-testid={TestIds.feat.quotes.card.expiryDate}>
        Expires {dateString}
      </ItemValue>
    )
  }
}

export const QuoteExpiry = memo(Expiry, (quote1, quote2) => {
  return quote1.quote.expiresOn === quote2.quote.expiresOn
})
